import { DriverModel } from './driver.model';
import * as moment from 'moment';
import { LocationModel } from './location.model';
import * as _ from 'lodash';
var OrderModel = /** @class */ (function () {
    // static dService: DistributorService;
    // static cService: CustomerService;
    function OrderModel(data, populate) {
        if (data.id)
            this.id = data.id;
        this.acceptExpire = data.acceptExpire;
        if (data.rescheduleExpire)
            this.rescheduleExpire = data.rescheduleExpire;
        if (data.attachments)
            this.attachments = data.attachments;
        this.comments = data.comments;
        this.customerID = data.customerID;
        this.date = new Date(data.date).getTime();
        this.disTotal = data.disTotal;
        this.distributor = data.distributor;
        this.deliveryDate = moment(data.deliveryDate, 'MM/DD/YYYY').unix() * 1000;
        this.deliveryHour = data.deliveryHour;
        if (data.discounts)
            this.discounts = data.discounts;
        this.orderNumber = data.orderNumber;
        this.retention = data.retention;
        this.selectedHours = data.selectedHours;
        this.specs = {
            location: new LocationModel(data.specs.location),
            product: data.specs.product,
            recipient: data.specs.recipient
        };
        this.status = data.status;
        if (data.status == 0 && data.acceptExpire < new Date().getTime())
            this.status = 8;
        if (data.status == 9 && data.rescheduleExpire < new Date().getTime())
            this.status = 6;
        this.total = Math.round(parseFloat(data.total) * 100) / 100;
        if (data.rejectReason)
            this.rejectReason = data.rejectReason;
        if (data.deliveryData)
            this.deliveryData = data.deliveryData;
        if (data.rating && data.status == 5)
            this.rating = data.rating;
        if (data.driver)
            this.driver = new DriverModel(data.driver);
    }
    Object.defineProperty(OrderModel.prototype, "totals", {
        get: function () {
            var totals = {
                amount: this.specs.product.amount,
                disTotal: this.disTotal,
                total: this.total
            };
            if (this.deliveryData)
                totals = this.deliveryData;
            var amountDiscounted = 0;
            if (this.discounts) {
                _.forEach(this.discounts, function (discount) {
                    if (discount.amount)
                        amountDiscounted += discount.amount;
                });
            }
            totals['discounts'] = amountDiscounted;
            totals['nonDiscountTotal'] = totals.total + amountDiscounted;
            return totals;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderModel.prototype, "fullAddress", {
        get: function () {
            return this.specs.location.fullAddress;
        },
        enumerable: true,
        configurable: true
    });
    return OrderModel;
}());
export { OrderModel };
